import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=42a12960&scoped=true"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"
import style0 from "./Pane.vue?vue&type=style&index=0&id=42a12960&prod&lang=scss"
import style1 from "./Pane.vue?vue&type=style&index=1&id=42a12960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a12960",
  null
  
)

export default component.exports